export const HOTEL_PAGE_PARAM_ROOM_ID = 'roomId'
export const HOTEL_PAGE_PARAM_RATE_ID = 'roomRateId'
export const PARAM_CTA_SELECT = 'ctaSelect'
